import type { Message } from '../types';
import { getLetterTheme, themeVars } from '../lib/letterThemes';
import { getLetterFont } from '../lib/letterFonts';
import { getLetterSize, sizeVars } from '../lib/letterSizes';
import { LetterSignatureView } from '../components/LetterSignatureView';

type Props = {
  message: Message;
  authorLabel: string; // e.g. @bob or "you"
  onClose: () => void;
};

export function LetterReader({ message, authorLabel, onClose }: Props) {
  const wordCount = message.body.trim()
    ? message.body.trim().split(/\s+/).length
    : 0;
  const readMins = Math.max(1, Math.round(wordCount / 220));
  const theme = getLetterTheme(message.letter_theme);
  const font = getLetterFont(message.letter_font);
  const size = getLetterSize(message.letter_size);

  const date = new Date(message.sent_at);
  const dateLabel = date.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <div
      className="letter-reader-overlay"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <article
        className="letter-reader"
        style={{ ...themeVars(theme), ...sizeVars(size) }}
        onClick={(e) => e.stopPropagation()}
      >
        <header className="letter-reader-head">
          <button
            type="button"
            className="btn btn-ghost btn-small"
            onClick={onClose}
          >
            ← Close
          </button>
          <span className="letter-reader-meta">
            {readMins} min read · {wordCount} words
          </span>
        </header>

        <div className="letter-reader-page">
          <div className="letter-reader-author">
            {authorLabel} · {dateLabel}
          </div>
          {message.title && (
            <h1 className="letter-reader-title" style={{ fontFamily: font.stack }}>
              {message.title}
            </h1>
          )}
          <div className="letter-reader-body" style={{ fontFamily: font.stack }}>
            {message.body.split(/\n\n+/).map((para, i) => (
              <p key={i}>{para}</p>
            ))}
          </div>
          {message.letter_signature && (
            <div className="letter-signature-block reader">
              <LetterSignatureView signature={message.letter_signature} />
            </div>
          )}
        </div>
      </article>
    </div>
  );
}
